module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD+SURBVHgBpdS9rYMwFAXgE+s1FFAwAxIjsAAFNCwAA9CwBCvQUNDQMAANrEDFAhRUlEiIgvIlFykoAfLjmyNZtq+tT7J05cv/Ldil67p1NgwDsvnbF5qmQVEU69pxHLiuC5mIfWFZlm1d1zWqqsJPoGVZ0HWdjR5ARVEQRREbFWdFwrioeHXARcW7Qw56OevDfcZxRJIk60yZpgm2bSMIAh74iLZti77v11ocx/A87+mewJehZ2uatmGUYRgO974G0zRFnufb3jRN+L7PAwmj8YhlWQZVVeVBGewjKIu9BTnYS5CLnYJlWbKxU3CeZzZGOfzY1Pn3hg3DUAqjXAHxs4rSk38iMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/transfer/select_icon.png
// module id = IU3U
// module chunks = 1